// Recovered compiled webpack factory 24531. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { S: () => n });
  let n = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
}
